import React from "react";
import { Link } from "react-router-dom";

import RegisterProfileSetup from "./register/RegisterProfileSetup";
import {
  RegisterAccountSection,
  RegisterRequiredProfileSection,
} from "./register/RegisterFormSections";
import useRegisterFormState from "./register/useRegisterFormState";
import "../styles/pages/Register.css";

export default function Register({ setUser }) {
  const register = useRegisterFormState({ setUser });
  const verificationRequiredState = register.verificationRequiredState;

  return (
    <div className="register-page">
      <div className="register-card">
        {verificationRequiredState ? (
          <div className="register-verification-state">
            <div className="register-verification-badge">
              {register.t("register_verification_required_badge", {
                defaultValue: "Email verification required",
              })}
            </div>
            <h2 className="register-verification-title">
              {register.t("register_verification_required_title", {
                defaultValue: "Check your email",
              })}
            </h2>
            <p className="register-verification-text">
              {verificationRequiredState.message}
            </p>
            {verificationRequiredState.email ? (
              <p className="register-verification-email">
                {register.t("register_verification_required_email_hint", {
                  defaultValue: "We sent a verification email to {{email}}.",
                  email: verificationRequiredState.email,
                })}
              </p>
            ) : null}
            <p className="register-verification-text register-verification-text--muted">
              {register.t("register_verification_required_next_step", {
                defaultValue:
                  "Once you verify your email, return here and log in with your account.",
              })}
            </p>
            <button
              type="button"
              className="register-verification-button"
              onClick={register.goToLogin}
            >
              {register.t("login_here")}
            </button>
          </div>
        ) : (
          <>
            {register.step === 1 && <RegisterAccountSection register={register} />}
            {register.step === 2 && (
              <RegisterRequiredProfileSection register={register} />
            )}
            {register.step === 3 && <RegisterProfileSetup register={register} />}
          </>
        )}

        <div className="register-legal-links">
          <div className="register-legal-title">
            {register.t("legal_documents_label")}
          </div>
          <Link to="/legal/terms" className="register-legal-link">
            {register.t("legal_document_terms_title")}
          </Link>{" "}
          |{" "}
          <Link to="/legal/privacy" className="register-legal-link">
            {register.t("legal_document_privacy_title")}
          </Link>{" "}
          |{" "}
          <Link to="/legal/attributions" className="register-legal-link">
            {register.t("legal_document_attributions_title")}
          </Link>
        </div>
      </div>
    </div>
  );
}
